import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import FieldLabelWrapper from '../../../../../../../../../features/components/Form/FieldLabelWrapper'
import Field from '../../../../../../../../../components/Form/Field'

import { AD_CREATIVES, CLICK_THROUGH_LINK, MEDIA_HEIGHT, MEDIA_WIDTH, THIRD_PARTY_TAG } from '../../../../../../fields'

import { formatPastedJavascriptTags } from '../../../../../../helpers'

const JavascriptTagFields = ({ formik, index }) => {
  const { t } = useTranslation()

  return (
    <>
      <FieldLabelWrapper label={t('Url')} labelFor={`${AD_CREATIVES}[${index}][${CLICK_THROUGH_LINK}]`}>
        <Field placeholder={t('Url')} formik={formik} name={`${AD_CREATIVES}[${index}][${CLICK_THROUGH_LINK}]`} />
      </FieldLabelWrapper>
      <FieldLabelWrapper label={t('JavaScript Tag')} labelFor={`${AD_CREATIVES}[${index}][${THIRD_PARTY_TAG}]`}>
        <Field
          placeholder={t('JavaScript Tag')}
          formik={formik}
          name={`${AD_CREATIVES}[${index}][${THIRD_PARTY_TAG}]`}
          isTextarea={true}
          modifyValueOnBlur={formatPastedJavascriptTags}
        />
      </FieldLabelWrapper>
      <FieldLabelWrapper label={t('Width')} labelFor={`${AD_CREATIVES}[${index}][${MEDIA_WIDTH}]`}>
        <Field
          placeholder={t('Width')}
          formik={formik}
          name={`${AD_CREATIVES}[${index}][${MEDIA_WIDTH}]`}
          type="number"
          decimalScale={0}
        />
      </FieldLabelWrapper>
      <FieldLabelWrapper label={t('Height')} labelFor={`${AD_CREATIVES}[${index}][${MEDIA_HEIGHT}]`}>
        <Field
          placeholder={t('Height')}
          formik={formik}
          name={`${AD_CREATIVES}[${index}][${MEDIA_HEIGHT}]`}
          type="number"
          decimalScale={0}
        />
      </FieldLabelWrapper>
    </>
  )
}

JavascriptTagFields.propTypes = {
  formik: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired
}

export default JavascriptTagFields
